import type { BriefAttachment, BusinessType } from "../../../../lib/api";
import { BUSINESS_TYPES, CAPABILITIES, type Hours } from "../../../../lib/catalog";
import { summarizeHours } from "../../shared";

export function ReviewBlock({
  type, name, tagline, description, address, phone, email, hours,
  capIds, integrationIds, inspoUrls, ownerNote, attachments, logoPreview, onEdit,
}: {
  type: BusinessType;
  name: string;
  tagline: string;
  description: string;
  address: string;
  phone: string;
  email: string;
  hours: Hours;
  capIds: string[];
  integrationIds: string[];
  inspoUrls: string[];
  ownerNote: string;
  attachments: BriefAttachment[];
  logoPreview: string | null;
  onEdit: (step: number) => void;
}) {
  const typeLabel = BUSINESS_TYPES.find((t) => t.value === type)?.label ?? type;
  const capLabels = capIds
    .map((id) => CAPABILITIES.find((c) => c.id === id)?.label)
    .filter(Boolean) as string[];
  const logoCount = attachments.filter((a) => a.tag === "logo").length;
  const photoCount = attachments.filter((a) => a.tag === "photo").length;
  const mediaSummary = [
    logoCount ? "logo" : null,
    photoCount ? `${photoCount} photo${photoCount === 1 ? "" : "s"}` : null,
  ].filter(Boolean).join(" · ");

  return (
    <div className="card" style={{ background: "#ecfdf5", borderColor: "#a7f3d0" }}>
      <div className="row between" style={{ marginBottom: 10 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#065f46" }}>Review</div>
        {logoPreview && (
          <img src={logoPreview} alt="logo" style={{
            width: 36, height: 36, borderRadius: 6, objectFit: "contain",
            border: "1px solid #a7f3d0", background: "white", padding: 2,
          }} />
        )}
      </div>
      <ReviewLine onEdit={() => onEdit(1)} label="Type" value={typeLabel} />
      <ReviewLine onEdit={() => onEdit(2)} label="Name" value={tagline ? `${name} — ${tagline}` : name} />
      <ReviewLine onEdit={() => onEdit(2)} label="About" value={description.length > 140 ? description.slice(0, 140) + "…" : description} />
      <ReviewLine onEdit={() => onEdit(3)} label="Contact"
        value={[address, phone, email].filter(Boolean).join(" · ") || "(none)"} />
      <ReviewLine onEdit={() => onEdit(3)} label="Hours"
        value={summarizeHours(hours)} />
      <ReviewLine onEdit={() => onEdit(4)} label="Capabilities"
        value={capLabels.length ? capLabels.join(", ") : "(none)"} />
      <ReviewLine onEdit={() => onEdit(5)} label="Integrations"
        value={integrationIds.length ? integrationIds.join(", ") : "(none)"} />
      <ReviewLine onEdit={() => onEdit(6)} label="Inspiration"
        value={inspoUrls.length ? inspoUrls.join(", ") : "(none)"} />
      <ReviewLine onEdit={() => onEdit(7)} label="Media"
        value={mediaSummary || "(none)"} />
      <ReviewLine onEdit={() => onEdit(7)} label="Note"
        value={ownerNote || "(none)"} />
    </div>
  );
}

function ReviewLine({ label, value, onEdit }: { label: string; value: string; onEdit: () => void }) {
  return (
    <div className="row between" style={{ padding: "6px 0", borderBottom: "1px solid #d1fae5", gap: 12 }}>
      <div style={{ minWidth: 100, fontSize: 12, fontWeight: 600, color: "#065f46", textTransform: "uppercase", letterSpacing: 0.05 }}>
        {label}
      </div>
      <div style={{ flex: 1, fontSize: 14, color: "#064e3b" }}>{value}</div>
      <button type="button" onClick={onEdit} style={{
        background: "transparent", border: "none", color: "#047857",
        fontSize: 12, fontWeight: 600, cursor: "pointer", padding: 0,
      }}>
        Edit
      </button>
    </div>
  );
}

